import React, { useState } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import 'react-html5-camera-photo/build/css/index.css';
import { UploadPhoto } from '../../../s3Func/s3Upload';
import PopUp from '../../../Popup/logoutPopup';
import { CloudfrontVideoFormat } from '../../../videos/CloudfrontVideoFormat';

import SingingIntroduction from './components/SingingIntroduction';
import SingingPage from './components/SingingPage';
import SingingDecision from './components/SingingDecision';
import SingingRecord from './components/SingingRecord';
import SingVideoPlayer from './components/SingVideoPlayer';
import SingingPageIntro from './components/SingingPageIntro';
import SingAlongPopup from './components/popup/SingAlongPopup';
import SingingRecordPreview from './components/SingingRecordReview';

/**
 * The SingingTime section of each module allows the child to sing along with
 * the characters of the module and record their voice. This will then be used
 * in later sections such as learn and the surprise video.
 */
export default function SingingTime(props) {
  // Initialize variables to be used later.
  const dispatch = useDispatch();
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);

  const [displaySingingVideo, setDisplaySingingVideo] = useState(true);
  const [displayDecision, setDisplayDecision] = useState(false);
  const [displayIntroduction, setDisplayIntroduction] = useState(false);
  const [displaySingingPage, setDisplaySingingPage] = useState(false);
  const [singPageStep, setSingPageStep] = useState('intro');
  const [recordConfiguration, setRecordConfiguration] = useState(null);

  const [singAlongMessage, setSingAlongMessage] = useState(false);

  const [recordUrl, setRecordUrl] = useState(null);

  const handleDecisionYes = async () => {
    setDisplayDecision(false);
    setDisplayIntroduction(true);

    const { permissions, mediaDevices } = navigator;
    const { state } = await permissions.query({ name: 'microphone' });

    if (state === 'granted') {
      // console.log('permission granted');
    } else {
      navigator.mediaDevices.getUserMedia({
        audio: true,
        video: false,
      });
    }
  };

  const handleDecisionNo = () => {
    if (!props.module.reviewIcon) {
      dispatch({
        type: `${props.moduleNum}_SET_stepCompleted`,
        payload: 'singingtime',
      });
    }
    props.setDisplaySingingTime(false);
  };

  const handleIntroductionBack = () => {
    setDisplayIntroduction(false);
    setDisplayDecision(true);
  };

  const handleIntroductionNext = () => {
    setDisplayIntroduction(false);
    setDisplaySingingPage(true);
  };

  const handleBackClick = () => {
    if (singPageStep === 'intro') {
      setDisplaySingingPage(false);
      setDisplayIntroduction(true);
    }

    setSingPageStep('intro');
  };

  const handlePlayClick = () => {
    if (singPageStep === 'intro') {
      setSingPageStep('demo');
    }
  };

  const handleRecordClick = () => {
    setSingAlongMessage(true);
  };

  const handleSingAlongOption = (option) => {
    setSingPageStep('record');
    setSingAlongMessage(false);

    const video =
      option === 'confirm' ? props.singingAlongVideo : props.instrumentalVideo;

    setRecordConfiguration({ video });
  };

  const handleRecordEnd = (blobUrl) => {
    setRecordUrl(blobUrl);
    setSingPageStep('ending');
  };

  const handleCancelRecord = () => {
    setRecordUrl(null);
    setSingPageStep('intro');
  };

  const handleConfirmRecord = async () => {
    if (!props.module.reviewIcon) {
      dispatch({
        type: `${props.moduleNum}_SET_stepCompleted`,
        payload: 'singingtime',
      });
    }
    const result = await UploadPhoto(recordUrl, 'userfiles', `${props.name}_play_day_music.m4a`, 'audio/m4a', login.studentid);
    if (result === 200){
      props.setDisplaySingingTime(false);
    }
    else{
      window.alert('Whoops, failed to upload. It looks like the internet connection was lost. Please try again after login.');
      window.location.reload(false);
    }
  };

  // The HTML code to create the recorder as well as several popup questions to be asked before the recording is started.
  return (
    <>
      {displaySingingVideo && (
        <CloudfrontVideoFormat
          source={props.introVideo}
          back='/unit1'
          background={props.background}
          close={props.setDisplaySingingTime}
          ended={() => {
            setDisplaySingingVideo(false);
            setDisplayDecision(true);
          }}
        />
      )}

      {displayDecision && (
        <SingingDecision
          onYesClick={handleDecisionYes}
          onNoClick={handleDecisionNo}
        />
      )}

      {displayIntroduction && (
        <SingingIntroduction
          onBackClick={handleIntroductionBack}
          onNextClick={handleIntroductionNext}
        />
      )}

      {displaySingingPage && (
        <SingingPage step={singPageStep} onBackClick={handleBackClick}>
          {singPageStep === 'intro' && (
            <SingingPageIntro
              onPlayClick={handlePlayClick}
              onRecordClick={handleRecordClick}
              moduleName={props.moduleNum}
              singAlongMessage={singAlongMessage}
            />
          )}

          {singPageStep === 'demo' && (
            <SingVideoPlayer
              video={props.singingAlongVideo}
              onRecordClick={handleRecordClick}
              onDemoEnded={() => setSingPageStep('intro')}
            />
          )}

          {singPageStep === 'record' && (
            <SingingRecord
              video={recordConfiguration.video}
              onCancelRecord={handleCancelRecord}
              onRecordEnd={handleRecordEnd}
              setSingPageStep={setSingPageStep}
            />
          )}

          {singPageStep === 'ending' && recordUrl && (
            <SingingRecordPreview
              recordUrl={recordUrl}
              audio={props.instrumentalMusic}
              onConfirmRecord={handleConfirmRecord}
              onCancelRecord={handleCancelRecord}
              setRecordUrl={setRecordUrl}
            />
          )}
        </SingingPage>
      )}

      {singAlongMessage && (
        <PopUp
          content={
            <SingAlongPopup
              onSingAlongConfirm={() => handleSingAlongOption('confirm')}
              onSingAlongReject={() => handleSingAlongOption('reject')}
            />
          }
        />
      )}
    </>
  );
}
